<template>
    <div
        class="delete-modal"
    >
        <modal
            :show="true"
            modal-classes="modal-secondary"
            :data-cy="'deleteModal'"
            @close="$emit('close-delete')"
        >
            <template slot="header">
                <h1>{{ isIncome ? $t("pages.cashFlow.deleteModalTitle.incoming") : $t("pages.cashFlow.deleteModalTitle.outcoming") }}</h1>
            </template>

            <p>
                {{ isIncome ? $t("pages.cashFlow.deleteMessage.incoming", { number }) : $t("pages.cashFlow.deleteMessage.outcoming", { number }) }}
            </p>
            <p>
                {{ $t("modalMessages.unrecoverableOperationMessage") }}
            </p>

            <template slot="footer">
                <base-button
                    type="submit"
                    class="btn btn-danger"
                    :loading="loading"
                    :data-cy="'buttonDeleteConfirm'"
                    @click="deleteCashFlow"
                >
                    {{ $t("actions.delete") }}
                </base-button>
                <base-button
                    type="button"
                    class="btn btn-neutral"
                    :data-cy="'buttonDeleteStop'"
                    @click="$emit('close-delete')"
                >
                    {{ $t("actions.cancel") }}
                </base-button>
            </template>
        </modal>
    </div>
</template>

<script>
import { cashFlowClient } from "@/clients/cashFlowClient";
import exceptionsMixins from "@/mixins/exceptionsMixins";

export default {
    name: 'DeleteCashFlow',
    mixins: [
        exceptionsMixins
    ],
    props: {
        deleteCashFlowId: {
            type: Number,
        },
        isIncome: {
            type: Boolean,
        },
        number: {
            type: String,
        }
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        deleteCashFlow() {
            this.loading = true;
            cashFlowClient.delete(this.deleteCashFlowId).then(() => {
                this.$notify({
                    type: "success",
                    icon: "ni ni-notification-70",
                    message: this.$t("notifications.success.deleted")
                });
                this.$emit('data-changed');
            }).catch((error) => {
                this.manageException(error.response);
            }).then(() => {
                this.loading = false;
                this.$emit('close-delete');
            });
        },
    }
}
</script>
